export default "<router-outlet></router-outlet>\n<ng-snotify class=\"dark\"></ng-snotify>";